import { z } from "zod";
import { LearningDisclosureSchema } from "./participant-learning.schemas.js";

/**
 * A reason to meet someone, plus what it rests on: the learnings it cites and
 * the disclosure of the run that produced it — a run sees learnings of one side
 * only — which is what a reader checks before voicing the reason.
 */
export const ParticipantReasonToMeetSchema = z.object({
  type: z.string(),
  signal: z.string(),
  direction: z.string(),
  confidence: z.string(),
  source: z.string(),
  learningRefs: z.array(z.string()),
  disclosure: LearningDisclosureSchema,
});

/** Read back as any disclosure, written only as these: `sensitive` rows predate the two-run split. */
export const ReasonDisclosureSchema = LearningDisclosureSchema.exclude([
  "sensitive",
]);
export type ReasonDisclosure = z.infer<typeof ReasonDisclosureSchema>;

export type ParticipantReasonToMeet = z.infer<
  typeof ParticipantReasonToMeetSchema
>;

/**
 * One content hash per input the reasons were computed from, so a later reader
 * can tell which input moved since.
 */
export const ReasonsToMeetInputHashesSchema = z.object({
  participant: z.string(),
  enrichment: z.string(),
  company: z.string(),
  learnings: z.string(),
  eventDescription: z.string(),
});

export type ReasonsToMeetInputHashes = z.infer<
  typeof ReasonsToMeetInputHashesSchema
>;
